let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hjtOe")).then(() => parcelRequire('27gZm'));